import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";
import { classNames } from "Utils/utils";
import { VERTEX360_COPILOT_RESPONDING_LABEL } from "../constants/vertex360CopilotConstants";
import { VERTEX360_COPILOT_THEME } from "../constants/vertex360CopilotTheme";

const SIZE_MAP = {
  sm: { shell: "h-8 w-8", icon: "h-3.5 w-3.5" },
  md: { shell: "h-9 w-9", icon: "h-4 w-4" },
  lg: { shell: "h-10 w-10", icon: "h-5 w-5" },
};

/**
 * Vertex360 Copilot AI icon — pass `animated` while waiting for / receiving a stream.
 * @param {{ animated?: boolean, size?: 'sm' | 'md' | 'lg', className?: string }} props
 */
const Vertex360CopilotAiIcon = ({ animated = false, size = "md", className = "" }) => {
  const dims = SIZE_MAP[size] || SIZE_MAP.md;

  return (
    <span
      className={classNames(
        "relative inline-flex shrink-0 items-center justify-center rounded-xl text-white shadow-md shadow-[#4B6CB7]/20",
        dims.shell,
        VERTEX360_COPILOT_THEME.heroGradient,
        animated && "copilot-ai-icon-active",
        className
      )}
      aria-hidden={animated ? undefined : true}
      aria-label={animated ? VERTEX360_COPILOT_RESPONDING_LABEL : undefined}
    >
      {animated ? (
        <span
          className="pointer-events-none absolute inset-0 rounded-xl copilot-ai-icon-ring"
          aria-hidden="true"
        />
      ) : null}
      <HiOutlineSparkles
        className={classNames(
          "relative",
          dims.icon,
          animated && "copilot-ai-sparkle"
        )}
      />
    </span>
  );
};

export default Vertex360CopilotAiIcon;
